import React, {useEffect} from 'react';
// import {get} from 'lodash';
import nprops from 'nested-props';
import CountUp from 'react-countup';
import Svgs from '../../resources/svgs';
import Widget from './widget';
import './habits.scss';
import esriStrings from '../../resources/esriStrings';
import layerUrls from '../../resources/vtlayers';

const Habits = (props) => {
  const [attributes, setAttributes] = React.useState({});
  const [activeCell, setActiveCell] = React.useState('credit');
  const [activeLayerUrl, setActiveLayerUrl] = React.useState(layerUrls.credit);

  useEffect(() => {
    const fields = nprops.get(props.currentFeature, 'attributes.spending', null);
    if (fields) {
      // const [financial_x14068_x_i, clothing_x5001_x_i, health_x8002_x_i, entertainment_x9001_x_i] = fields;
      setAttributes({
        credit: fields.X14068_X,
        apparel: fields.X5001_X,
        medical: fields.X8002_X,
        entertainment: fields.X9001_X
      });
    }
  }, [props.currentFeature]);

  useEffect(() => {
    if (props.isActive) {
      props.setActiveLegend(activeCell);
    }
  }, [activeCell]);

  useEffect(() => {
    if (props.isActive) {
      props.onUpdateLayer(activeLayerUrl);
      props.setActiveLegend(activeCell);
    }
  }, [props.isActive]);
  const handleCellClick = (id) => {
    const url = layerUrls[id];
    if (url) {
      setActiveLayerUrl(url);
      props.onUpdateLayer(url);
    } else {
      const defaultUrl =
        'https://tiles.arcgis.com/tiles/G84Qg78md8fRCEAD/arcgis/rest/services/ZipCodes_base_vtl/VectorTileServer';
      props.onUpdateLayer(defaultUrl);
    }
    setActiveCell(id);
    if (!props.isActive) {
      setActiveLayerUrl(url);

      props.onWidget(2);
    }
  };
  const handleClick = () => {
    props.onWidget(2);
  };

  return (
    <Widget
      isActive={props.isActive}
      title={esriStrings.widgetTwo}
      info={props.info}
      onWidget={handleClick}
    >
      <div className="habit-grid">
        <div
          className={`habit-cell credit${
            props.isActive && activeCell === 'credit' ? ' habit-cell-active' : ''
          }`}
        >
          <div
            className="habit-cell-content"
            onClick={() => handleCellClick('credit')}
          >
            {Svgs.creditCard}
            <div>{esriStrings.creditLabel}</div>
            <CountUp
              separator=","
              prefix="$"
              end={
                typeof attributes.credit === 'undefined'
                  ? 0
                  : attributes.credit
              }
            />
          </div>
        </div>
        <div
          className={`habit-cell apparel${
            props.isActive && activeCell === 'apparel' ? ' habit-cell-active' : ''
          }`}
        >
          <div
            className="habit-cell-content"
            onClick={() => handleCellClick('apparel')}
          >
            {Svgs.retail}
            <div>{esriStrings.apparelLabel}</div>
            <CountUp
              separator=","
              prefix="$"
              end={
                typeof attributes.apparel === 'undefined'
                  ? 0
                  : attributes.apparel
              }
            />
          </div>
        </div>
        <div
          className={`habit-cell medical${
            props.isActive && activeCell === 'medical' ? ' habit-cell-active' : ''
          }`}
        >
          <div
            className="habit-cell-content"
            onClick={() => handleCellClick('medical')}
          >
            {Svgs.healthCare}
            <div>{esriStrings.medicalLabel}</div>
            <CountUp
              separator=","
              prefix="$"
              end={
                typeof attributes.medical === 'undefined'
                  ? 0
                  : attributes.medical
              }
            />
          </div>
        </div>
        <div
          className={`habit-cell entertainment${
            props.isActive && activeCell === 'entertainment' ? ' habit-cell-active' : ''
          }`}
        >
          <div
            className="habit-cell-content"
            onClick={() => handleCellClick('entertainment')}
          >
            {Svgs.video}
            <div>{esriStrings.entertainementLabel}</div>
            <CountUp
              separator=","
              prefix="$"
              end={
                typeof attributes.entertainment === 'undefined'
                  ? 0
                  : attributes.entertainment
              }
            />
          </div>
        </div>
      </div>
    </Widget>
  );
};

export default Habits;
